module.exports = __webpack_public_path__ + "img/uk-flag-icon.253809fa.svg";